import React, { useEffect, useState } from "react";
import {
  ReferenceField,
  TextField,
  Labeled,
  useDataProvider,
  Show,
  SimpleShowLayout,
  SelectField,
} from "react-admin";

import TitleBreadcrumb from "../../components/TitleBreadcrumb";
import { GetParam } from "utils/tools";

import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomDateField from "components/CustomDateField";
import { labelDataGridStyles } from "utils/style";
import ShowAreaDatagrid from "./components/ShowAreaDatagrid";
import CustomFormLabel from "components/CustomFormLabel";
import { tbfCodeList } from "./components/TbfCodeInput";

const RateChartShow = (props: any) => {
  const [areas, setAreas] = useState([]);
  const provider = useDataProvider();
  const param = GetParam();

  const breadcrumb = [
    { title: "Schools", link: `/schools` },
    { title: "Pricing", link: `/schools/${param.get("schoolId")}/show/5` },
    { title: props.id, link: "" },
  ];

  useEffect(() => {
    provider
      .getList("areas", {
        filter: { SchoolId: Number(param.get("schoolId")) },
        pagination: {
          page: 1,
          perPage: 1000,
        },
        sort: {
          field: "MaxDistanceInMeters",
          order: "ASC",
        },
      })
      .then((result) => {
        setAreas(result.data);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <TitleBreadcrumb paths={breadcrumb} />
      <CustomFormLabel property={props} isNoActions customFieldName="name" />
      <Show {...props} actions={null}>
        <SimpleShowLayout>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">School & Academic Year</Typography>
            </Grid>

            <Grid item xs={3}>
              <Labeled source="School">
                <ReferenceField source="schoolId" reference="schools">
                  <TextField source="name" />
                </ReferenceField>
              </Labeled>
            </Grid>
            <Grid item xs={9}></Grid>

            <Grid item xs={3}>
              <Labeled source="Academic Year">
                <ReferenceField
                  source="academicYearId"
                  reference="academicYears"
                >
                  <TextField source="name" />
                </ReferenceField>
              </Labeled>
            </Grid>
            <Grid item xs={9}></Grid>

            <Grid item xs={3}>
              <Labeled source="Tbf Code">
                <SelectField
                  source="tbfCode"
                  choices={tbfCodeList}
                  emptyText="-"
                />
              </Labeled>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Pricing Details</Typography>
            </Grid>

            <Grid item xs={3}>
              <Labeled source="Pricing Name">
                <TextField source="name" />
              </Labeled>
            </Grid>
            <Grid item xs={9}></Grid>

            <Grid item xs={3}>
              <Labeled source="Pricing Start Date">
                <CustomDateField source="startedAt" />
              </Labeled>
            </Grid>

            <Grid item xs={3}>
              <Labeled source="Pricing End Date">
                <CustomDateField source="endedAt" />
              </Labeled>
            </Grid>
            <Grid item xs={6}></Grid>

            <Grid item xs={3}>
              <Labeled source="Invoice Issue Date">
                <CustomDateField source="invoiceIssuedAt" />
              </Labeled>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6">
                Area Pricing (Inclusive of GST)
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Grid item xs={12}>
                <Typography variant="subtitle2" style={labelDataGridStyles}>
                  1 Time a Week
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <ShowAreaDatagrid
                  areas={areas}
                  name="oneTimeAWeekPricing"
                  frequency={1}
                  isDisabled
                />
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <Grid item xs={12}>
                <Typography variant="subtitle2" style={labelDataGridStyles}>
                  2 Time a Week
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <ShowAreaDatagrid
                  areas={areas}
                  name="twoTimeAWeekPricing"
                  frequency={2}
                  isDisabled
                />
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <Grid item xs={12}>
                <Typography variant="subtitle2" style={labelDataGridStyles}>
                  3 Time a Week
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <ShowAreaDatagrid
                  areas={areas}
                  name="threeTimeAWeekPricing"
                  frequency={3}
                  isDisabled
                />
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <Grid item xs={12}>
                <Typography variant="subtitle2" style={labelDataGridStyles}>
                  4 Time a Week
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <ShowAreaDatagrid
                  areas={areas}
                  name="fourTimeAWeekPricing"
                  frequency={4}
                  isDisabled
                />
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <Grid item xs={12}>
                <Typography variant="subtitle2" style={labelDataGridStyles}>
                  5 Time a Week
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <ShowAreaDatagrid
                  areas={areas}
                  name="fiveTimeAWeekPricing"
                  frequency={5}
                  isDisabled
                />
              </Grid>
            </Grid>
          </SanitizedGrid>
        </SimpleShowLayout>
      </Show>
    </>
  );
};

export default RateChartShow;
